/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Building_Holidays_Settings_WarningInputs */



/**
* | output |
* | --- |
* | "All building rooms will switch to frost-free mode" |
*
* @param {Building_Holidays_Settings_WarningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const building_holidays_settings_warning = /** @type {((inputs?: Building_Holidays_Settings_WarningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Building_Holidays_Settings_WarningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("All building rooms will switch to frost-free mode")
	return /** @type {LocalizedString} */ ("Toutes les pièces du bâtiment passeront en Hors Gel")
});